import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import DocumentPage from "./DocumentPage";

const HomePage: React.FC = () => (
  <div style={{ padding: "20px", textAlign: "center" }}>
    <h2>Mirror AI Document</h2>
  </div>
);

function App(): React.JSX.Element {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:app/:agreement" element={<DocumentPage />} />
      </Routes>
    </Router>
  );
}

export default App;
